import * as model from './model';
import { citySearchHistoryLib as lib } from './lib';

export const citySearchHistory = {
  lib,
  model,
};
